export default __webpack_public_path__ + "ab90bc26feba30e41f75fc8e17317b34.png";